import { Fragment, memo } from "react";
import CustomNode from "./components/CustomNode";
import SoftBox from "components/SoftBox";

const LabelNode = ({ data, id, selected }) => {
  const generateTooltip = () => {
    const description = data?.flowElement?.data?.description?.value || "";
    return (
      <Fragment>
        <SoftBox className="custom-node-tooltip">
          <p className="custom-node-tooltip-description">{description}</p>
        </SoftBox>
      </Fragment>
    );
  };

  return (
    <CustomNode isLabel={true} data={data} id={id} selected={selected} generateTooltip={generateTooltip} />
  );
};

export default memo(LabelNode);
